<template>
  <div class="home-page" :style="enFontFamily">
    <!--        banner-->
    <swiperBanner
      v-if="bannerList.length > 0"
      :banner-list="isMobile ? bannerListMobile : bannerList"
    />
    <!--        热销品牌-->
    <section class="home-section sec1">
      <div class="wp">
        <div class="section-title">
          <h3 class="title1" :style="{ ...enBold, ...enFontFamily }">
            {{ $t('home.title.sec1') }}
          </h3>
        </div>
        <div class="hot-sale-list">
          <hotSaleItem
            v-for="(item, index) in hotSaleList"
            :key="index"
            :item="item"
            :lang="lang"
          />
        </div>
        <div class="swi-hot-sale">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in hotSaleList"
              :key="index"
              class="swiper-slide"
            >
              <hotSaleItem :item="item" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--        新品上市-->
    <section class="home-section sec2">
      <div class="wp">
        <div class="section-title jcsb">
          <h3 class="title1" :style="{ ...enBold, ...enFontFamily }">
            {{ $t('home.title.sec2') }}
          </h3>
          <router-link
            :to="
              $i18n.locale === 'zh'
                ? '/product?other_tag=新品上市'
                : '/product?tags=New Arrivals'
            "
            class="big-btn"
            >{{ $t('home.viewAll') }}
          </router-link>
        </div>
        <div class="goods-list" v-if="newArrivals.length > 0">
          <goodsItem
            v-for="item in lang === 'zh' ? newArrivals : newArrivalsEn"
            :key="item.id"
            :item="item"
            :show-brand="true"
          />
        </div>
      </div>
    </section>
    <section
      class="row-section row-sec1"
      v-if="Object.keys(middleBanner).length > 0"
    >
      <a :href="middleBanner.url" target="_blank">
        <img
          alt="中国食品批发-美国华源食品集团, OCM Foods Group - Asian food distributor America"
          class="bg"
          :src="middleBanner.banner.data.attributes.url"
        />
      </a>
      <div class="wp">
        <div class="txt">
          <div
            class="title1"
            :style="{ ...enBold, ...enFontFamily, fontSize: '36px' }"
          >
            {{ middleBanner.title }}
          </div>
          <p>{{ middleBanner.subtitle }}</p>
        </div>
      </div>
    </section>
    <!--        新闻中心-->
    <section class=" home-section sec3">
      <div class="wp">
        <div class="section-title jcc">
          <h3 class="title1" :style="{ ...enBold, ...enFontFamily }">
            {{ $t('home.title.sec3') }}
          </h3>
        </div>
        <div class="news-list">
          <newsItem
            v-for="item in newsList"
            :key="item.id"
            :item="item"
            :type="2"
          />
        </div>
        <router-link to="/news" class="small-btn hollow">
          {{ $t('home.viewMore') }}
        </router-link>
      </div>
    </section>
    <section class="row-section row-sec2">
      <div class="txt">
        <h3 class="title1" :style="{ ...enBold, ...enFontFamily }">
          {{ $t('home.txt3') }}
        </h3>
        <p class=" semibold-16px">{{ $t('home.txt4') }}</p>
      </div>
    </section>
    <!--        合作品牌-->
    <section class="home-section sec4">
      <div class="wp">
        <div class="section-title">
          <h3 class="title1" :style="{ ...enBold, ...enFontFamily }">
            {{ $t('home.title.sec4') }}
          </h3>
        </div>
        <BrandSwiper :brandList="brandList" />
        <router-link to="/brand" class="small-btn">
          {{ $t('home.viewMore') }}
        </router-link>
      </div>
    </section>
    <!--        我们的位置-->
    <section class="home-section sec5">
      <div class="wp">
        <div class="section-title jcc">
          <h3 class="title1" :style="{ ...enBold, ...enFontFamily }">
            {{ $t('home.title.sec5') }}
          </h3>
        </div>
        <div class="position">
          <div class="left">
            <positionMap />
          </div>
          <div class="right">
            <p>{{ $t('home.txt5') }}</p>
            <ul>
              <li>
                <i></i>
                <span>City of Industry, CA</span>
              </li>
              <li>
                <i></i>
                <span>Hayward, CA</span>
              </li>
              <li>
                <i></i>
                <span>Aurora, IL</span>
              </li>
              <li>
                <i></i>
                <span>Houston, TX</span>
              </li>
              <li>
                <i></i>
                <span>Linden, NJ</span>
              </li>
              <li>
                <i></i>
                <span>Pooler, GA</span>
              </li>
            </ul>
            <router-link to="/contactUs" class="small-btn hollow">
              {{ $t('home.contactus') }}
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!--        订阅我们的网站-->
    <section class="row-section row-sec3">
      <subscribe />
    </section>
  </div>
</template>

<script>
import qs from 'qs'
import swiperBanner from '@/views/homePage/modules/swiperBanner'
import hotSaleItem from '@/views/homePage/modules/hotSaleItem'
import goodsItem from '@/components/goodsItem'
import newsItem from '@/components/newsItem'
import positionMap from '@/components/positionMap'
import subscribe from '@/components/subscribe'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import BrandSwiper from './modules/BrandSwiper.vue'

export default {
  name: 'homePage',
  components: {
    swiperBanner,
    hotSaleItem,
    goodsItem,
    newsItem,
    positionMap,
    subscribe,
    BrandSwiper
  },
  data() {
    return {
      offsetTopHome: 0,
      lang: this.$i18n.locale,
      isMobile: false,
      bannerList: [],
      bannerListMobile: [],
      middleBanner: {},
      hotSaleList: [],
      newArrivals: [],
      newArrivalsEn: [],
      newsList: [],
      brandList: [],
      enFontFamily:
        this.$i18n.locale === 'zh'
          ? {}
          : {
              fontFamily: 'Arial'
            },
      enBold:
        this.$i18n.locale === 'zh'
          ? {}
          : {
              fontWeight: 'bold'
            }
    }
  },
  created() {
    this.getHomePage()
    this.getNewArrivals()
    this.getNews()
    this.getBrands()
  },
  activated() {
    this.changeBanner()
    this.initListener()
    window.scrollTo(0, this.offsetTopHome || 0)
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === 'productDetail' ||
      to.name === 'brandDetail' ||
      to.name === 'newsDetail'
    )
      this.offsetTopHome = document.documentElement.scrollTop
    else this.offsetTopHome = 0
    next()
  },
  deactivated() {
    this.destroyListener()
  },
  methods: {
    async getHomePage() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: {
          data: { attributes: res }
        }
      } = await this.$http.get(`${this.$strapiUrl}/home-page?${queryInfo}`)
      this.bannerList = res.Banners.reduce(
        (pre, curr) => [
          ...pre,
          {
            img: curr.banner_pc.data.attributes.url,
            banner_name: curr.slug,
            has_story: curr.has_story
          }
        ],
        []
      )
      this.bannerListMobile = res.Banners.reduce(
        (pre, curr) => [
          ...pre,
          {
            img: curr.banner_mobile.data.attributes.url,
            banner_name: curr.slug,
            has_story: curr.has_story
          }
        ],
        []
      )
      this.middleBanner = { ...res.Middle_Banner }
      delete res.Brands.id
      this.hotSaleList = [...Object.values(res.Brands)]
      setTimeout(() => {
        this.changeBanner()
      }, 0)
    },
    async getNewArrivals() {
      const { data: res } = await this.$http.get(
        `${this.$baseUrl}/get-newarrivals`
      )
      this.newArrivals = res.data.map((item) => {
        return {
          id: item._id,
          img: item.avatarPublicUrl,
          brand: item.brand_cn,
          name: item.item_cn
        }
      })
      this.newArrivalsEn = res.data.map((item) => {
        return {
          id: item._id,
          img: item.avatarPublicUrl,
          brand: item.brand_en,
          name: item.item_en
        }
      })
    },
    async getNews() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          sort: ['priority:desc', `date:desc`],
          pagination: {
            start: 0,
            limit: 3
          },
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: { data: res }
      } = await this.$http.get(`${this.$strapiUrl}/news?${queryInfo}`)
      this.newsList = res.map((item) => ({
        id: item.id,
        img: item.attributes.pic.data
          ? item.attributes.pic.data.attributes.url
          : '',
        title: item.attributes.title,
        date: item.attributes.date
      }))
    },
    async getBrands() {
      const queryInfo = qs.stringify(
        {
          locale: this.$i18n.locale,
          populate: 'deep'
        },
        {
          encodeValuesOnly: true
        }
      )
      const {
        data: { data: res }
      } = await this.$http.get(
        `${this.$strapiUrl}/homepage-brands?${queryInfo}`
      )
      this.brandList = res
    },
    initListener() {
      this.$_resizeHandler = this.myDebounce(() => {
        this.changeBanner()
      })
      window.addEventListener('resize', this.$_resizeHandler)
    },
    destroyListener() {
      window.removeEventListener('resize', this.$_resizeHandler)
      this.$_resizeHandler = null
    },
    changeBanner() {
      if (window.innerWidth <= 767) {
        this.initHotSaleSwiper()
      }
      this.isMobile = window.innerWidth <= 959
    },
    initHotSaleSwiper() {
      const hotSaleSwiper = new Swiper('.swi-hot-sale', {
        slidesPerView: 2.1,
        spaceBetween: 10
      })
    }
  },
  watch: {
    '$i18n.locale'(newValue) {
      this.lang = newValue
      this.getHomePage()
      this.getNews()
      this.getBrands()
      this.enFontFamily =
        newValue === 'zh'
          ? {}
          : {
              fontFamily: 'Arial'
            }
      this.enBold =
        newValue === 'zh'
          ? {}
          : {
              fontWeight: 'bold'
            }
    }
  }
}
</script>

<style lang="scss" scoped>
//homepage
.home-page {
  .sec1,
  .sec3,
  .sec5 {
    background: $white2;
  }
}

.home-section {
  padding: 60px 0;
}

.section-title {
  margin-bottom: 40px;
  line-height: 1;
}

.jcsb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.jcc {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hot-sale-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.row-sec1 {
  position: relative;

  .bg {
    display: block;
    width: 100%;
  }

  .wp {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%;

    .txt {
      max-width: 680px;
      text-align: center;
      color: $white2;

      .title1 {
        margin-bottom: 16px;
      }

      p {
        @extend .semibold-16px;
      }
    }
  }
}

.row-sec2 {
  padding: 60px 0;
  text-align: center;

  .txt {
    max-width: 780px;
    margin: 0 auto;

    .title1 {
      margin-bottom: 16px;
    }
  }
}

//position
.position {
  display: flex;
  justify-content: space-between;

  .left {
    flex: 0 0 680px;
  }

  .right {
    flex: 0 0 310px;

    p {
      @extend .regular-16px;
    }

    ul {
      margin: 32px 0;

      li {
        display: flex;
        align-items: center;

        i {
          display: block;
          width: 26px;
          height: 24px;
          background: url('~@/assets/images/position.png') no-repeat center
            center / contain;
          margin-right: 8px;
        }

        span {
          @extend .semibold-16px;
        }
      }

      li + li {
        margin-top: 16px;
      }
    }

    .small-btn {
      margin: 0;
    }
  }
}

.swi-hot-sale {
  display: none;
}

@media only screen and (max-width: 1199px) {
  .position .left {
    flex: 0 0 50%;
    width: 50%;

    ::v-deep {
      .position-map {
        width: 680px;
        -webkit-transform-origin: 0 50%;
        -moz-transform-origin: 0 50%;
        -ms-transform-origin: 0 50%;
        -o-transform-origin: 0 50%;
        transform-origin: 0 50%;
        -webkit-transform: scale(0.7);
        -moz-transform: scale(0.7);
        -ms-transform: scale(0.7);
        -o-transform: scale(0.7);
        transform: scale(0.7);
      }
    }
  }
}

@media only screen and (max-width: 959px) {
  .position .left {
    ::v-deep {
      .position-map {
        -webkit-transform: scale(0.5);
        -moz-transform: scale(0.5);
        -ms-transform: scale(0.5);
        -o-transform: scale(0.5);
        transform: scale(0.5);
      }
    }
  }

  .partner-list .partner-item {
    margin: 0 20px 40px;
  }
}

@media only screen and (max-width: 767px) {
  .hot-sale-list {
    display: none;
  }

  .swi-hot-sale {
    display: block;
    overflow: hidden;
  }

  .position {
    display: block;
  }

  .swi-ban-home {
    ::v-deep {
      .swiper-pagination-bullet {
        width: 4px;
        height: 4px;
      }

      .swiper-pagination-bullet:after {
        width: 16px;
        height: 16px;
      }

      .swiper-pagination.swiper-pagination-bullets {
        bottom: 10px;
      }
    }
  }

  .section-title {
    margin-bottom: 20px;
  }

  .swi-hot-sale .swiper-slide {
    height: auto;
  }

  ::v-deep {
    .hot-sale-item {
      margin: 0;
      max-width: none;
      max-height: none;
      padding: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .hot-sale-item .txt-box {
      position: static;
      min-width: 0;
      max-width: none;
      width: 100%;
      padding: 10px;
    }

    .hot-sale-item .txt-box h4 {
      font-size: 16px;
    }
  }

  .home-section {
    padding: 20px 0 40px;
  }

  .home-page .sec1 {
    background-color: #fff;
  }

  .goods-list {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .goods-list .goods-item {
    flex: 0 0 120px;
    margin: 0 20px 0 0;

    ::v-deep {
      .txt a {
        width: 138px;
        display: block;
      }
    }
  }

  .row-sec1 .wp .txt {
    text-align: left;
    padding-left: 20px;
  }

  .row-sec1 .wp .txt .title1 {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .row-sec1 .wp .txt p {
    font-size: 12px;
  }

  .home-section.sec3 {
    padding-top: 40px;
    position: relative;

    .small-btn {
      position: absolute;
      right: 20px;
      top: 40px;
    }
  }

  .home-section.sec3 .section-title.jcc {
    justify-content: flex-start;
  }

  .news-list {
    display: block;
    margin: 0;

    .news-item:first-child {
      display: block;
    }

    .news-item {
      width: 100%;
      margin: 0;
      display: none;
    }
  }

  .row-sec2 {
    padding: 40px 20px 20px;
    text-align: left;

    p {
      font-size: 14px;
      font-weight: normal;
      text-align: left;
    }
  }

  .partner-list {
    margin: 0 -9px 20px;
  }

  .partner-list .partner-item {
    margin: 0 6px 12px;
  }

  .section-title.jcc {
    justify-content: flex-start;
  }

  .position {
    position: relative;

    .right .small-btn {
      position: absolute;
      top: 45px;
      right: 0;
    }
  }

  .position .left {
    width: 100%;
    margin-top: -100px;
    margin-bottom: -50px;
  }

  .position .right p {
    font-size: 12px;
  }

  .position .right ul {
    display: flex;
    flex-wrap: wrap;

    li {
      flex: 0 0 50%;
    }
  }

  .position .right ul li span {
    font-size: 12px;
    font-weight: normal;
  }

  .home-section.sec4 .wp {
    position: relative;

    .small-btn {
      position: absolute;
      top: 2px;
      right: 20px;
    }
  }
}
</style>
